import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavigationComponent } from './navigation.component';
import {
    MatButtonModule,
    MatIconModule
  } from '@angular/material';

@NgModule({
    imports: [ RouterModule, CommonModule, MatButtonModule, MatIconModule ],
    declarations: [ NavigationComponent ],
    exports: [ NavigationComponent ],
})

export class NavigationModule {}
